module.exports = __webpack_public_path__ + "eb3c8666a15ade8ee08255bb88518234.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/face/glasses-heart.png
// module id = 2336
// module chunks = 0